import { render } from "./PercentPopEmp.vue?vue&type=template&id=d10f8fd2&ts=true"
import script from "./PercentPopEmp.vue?vue&type=script&lang=ts"
export * from "./PercentPopEmp.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__